import { Component, computed, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TNil } from '@app/app.interface';
import { ICampaignCreatorForm, ICtaForm } from '@campaign-form/campaign-form.interface';
import { DeliverableListComponent } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-step/deliverable-list/deliverable-list.component';
import { IDeliverableConfigurationApi } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-step/deliverable-list/deliverable-list.interface';
import { IExecution } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/execution-step/execution-list/execution/execution.interface';
import { EPlatformFeature } from '@enums/campaign.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [DeliverableListComponent, ReactiveFormsModule, TranslateModule],
  selector: 'app-deliverable-step',
  templateUrl: './deliverable-step.component.html',
})
export class DeliverableStepComponent {
  public readonly campaignCreatorsValue = input.required<FormGroup<ICampaignCreatorForm>['value'][]>();
  public readonly ctaForm = input.required<FormGroup<ICtaForm> | null>();
  public readonly customModeCreatorId = input<string | TNil>(null);
  public readonly deliverableConfigurations = input<IDeliverableConfigurationApi[] | null>(null);
  public readonly executionValues = input<IExecution[]>([]);
  public readonly selectedPlatformFeature = input.required<EPlatformFeature | null>();

  public readonly customModeDisabled = output<void>();

  public readonly creators = computed(() => {
    return this.campaignCreatorsValue().map((cc) => cc.creator!) ?? [];
  });
  public readonly customModeCreator = computed(() => {
    return this.campaignCreatorsValue().find((cc) => cc.creatorId === this.customModeCreatorId())?.creator;
  });
  public readonly customModeCreatorName = computed(() => {
    return this.customModeCreator()?.name ?? '';
  });
}
